import React from 'react';
import styles from './styles.scss';

var Stat = function Stat(props) {
  var value = props.value,
      label = props.label,
      type = props.type,
      wrapperClassName = props.wrapperClassName,
      labelClassName = props.labelClassName,
      valueClassName = props.valueClassName,
      labelAfterValue = props.labelAfterValue;
  var labelElement = /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles.statLabel, " ").concat(labelClassName || '')
  }, label);
  var wrapperClasses = "".concat(styles.stat, " ").concat(styles[type] || '', " ").concat(wrapperClassName || '');
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClasses
  }, !labelAfterValue && labelElement, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.statValue, " ").concat(valueClassName || '')
  }, value), labelAfterValue && labelElement);
};

Stat.TYPES = ['stat-xs', 'stat-sm', 'stat-lg', 'stat-xl'];
Stat.defaultProps = {
  type: null,
  wrapperClassName: null,
  labelClassName: null,
  valueClassName: null,
  labelAfterValue: false
};
export default Stat;